import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';

interface HistoryStore {
    history: string[];
    hasNavigatedBack: boolean;
    setNavigatedBack: (value: boolean) => void;
    hasHistory: () => boolean;
    pushHistory: (url: string) => void;
    popHistory: () => string;
    clearHistory: () => void;
}

const historyStore = createStore<HistoryStore>((set, get) => ({
    history: [],
    hasNavigatedBack: false,
    setNavigatedBack: (value) => set({ hasNavigatedBack: value }),
    hasHistory: () => get().history.length > 0,
    pushHistory: (url) => {
        set({ history: [...get().history, url] });
    },
    popHistory: () => {
        const history = [...get().history];
        if (history.length === 0) {
            throw new Error('History stack is empty');
        }
        const url = history.pop() as string;
        set({ history });
        return url;
    },
    clearHistory: () => set({ history: [] }),
}));

export const { pushHistory, popHistory, clearHistory, setNavigatedBack } = historyStore.getState();
export const hasNavigatedBack = () => historyStore.getState().hasNavigatedBack;
export const useHasNavigatedBack = () => useStore(historyStore, (store) => store.hasNavigatedBack);
export const useHasHistory = () => useStore(historyStore, (store) => store.hasHistory());

/**
 * @deprecated use useHasHistory instead.
 * Only use in special cases outside react, e.g. while migrating legacy redux selectors.
 * It doesn't return a reactive value, so for safety reasons, use as `() => getHasHistory()` in createSelector.
 * */
export const getHasHistory = () => {
    const { hasHistory } = historyStore.getState();
    return hasHistory();
};
